<ng-template #kvEditor let-rows="rows" let-label="label" let-hint="hint">
  <div class="dvm-pt-subsection">
    <div class="dvm-pt-subsection-head">
      <span>{{ label }}</span>
      <button type="button" class="dvm-pt-add-btn" (click)="addKvRow(rows)">+ Add</button>
    </div>
    <p class="dvm-pt-hint" *ngIf="hint">{{ hint }}</p>
    <div class="dvm-pt-kv-row" *ngFor="let row of rows; let ri = index">
      <input type="text" placeholder="Key" [(ngModel)]="row.key" />
      <input type="text" placeholder="Value" [(ngModel)]="row.value" />
      <button type="button" class="dvm-pt-remove-btn" (click)="removeKvRow(rows, ri)" aria-label="Remove row"><mat-icon>close</mat-icon></button>
    </div>
    <p class="dvm-pt-empty" *ngIf="!rows.length">None configured.</p>
  </div>
</ng-template>

<ng-template #endpointEditor let-rows="rows">
  <div class="dvm-pt-subsection">
    <div class="dvm-pt-subsection-head">
      <span>Endpoints</span>
      <button type="button" class="dvm-pt-add-btn" (click)="addEndpointRow(rows)">+ Add endpoint</button>
    </div>
    <div class="dvm-pt-kv-row" *ngFor="let row of rows; let ri = index">
      <input type="text" placeholder="functionName" [(ngModel)]="row.functionName" />
      <input type="text" placeholder="version" [(ngModel)]="row.version" />
      <button type="button" class="dvm-pt-remove-btn" (click)="removeEndpointRow(rows, ri)" aria-label="Remove row"><mat-icon>close</mat-icon></button>
    </div>
    <p class="dvm-pt-empty" *ngIf="!rows.length">None configured.</p>
  </div>
</ng-template>

<div class="dvm-interactions-overlay" (click)="onCancel()">
  <div class="dvm-interactions-modal dvm-pt-modal" (click)="$event.stopPropagation()">
    <div class="dvm-interactions-modal-head">
      <span>Request body — {{ endpointLabel }}</span>
      <button type="button" mat-icon-button (click)="onCancel()" aria-label="Close"><mat-icon>close</mat-icon></button>
    </div>
    <div class="dvm-interactions-modal-body">
      <p class="dvm-pt-intro">Applies to this endpoint only — every other endpoint keeps its own body. Each row's field values (whatever columns this table has) are sent automatically under the key below; that's the DYNAMIC part, no setup needed. Everything else here is STATIC — identical on every call to this endpoint. Leave it all empty to post the default contract.</p>

      <div class="dvm-pt-field">
        <label>Row values key</label>
        <input type="text" [(ngModel)]="draft.dataKey" placeholder="requestData" />
      </div>

      <!-- Which of the row's fields go into the payload. None checked = every
           column of the table (hidden ones included). -->
      <div class="dvm-pt-subsection">
        <div class="dvm-pt-subsection-head">
          <span>Columns to send</span>
          <button type="button" class="dvm-pt-add-btn" *ngIf="draft.includeColumns.length" (click)="clearColumns()">Send all</button>
        </div>
        <p class="dvm-pt-hint">
          {{ draft.includeColumns.length
              ? 'Only the checked columns are sent.'
              : 'Nothing checked — every column of the table is sent. Check specific columns to send only those.' }}
        </p>
        <div class="dvm-pt-col-grid" *ngIf="availableColumns.length">
          <label class="dvm-pt-col-item" *ngFor="let column of availableColumns">
            <input type="checkbox" [checked]="isColumnSelected(column)" (change)="toggleColumn(column)" />
            <span>{{ column }}</span>
          </label>
        </div>
        <p class="dvm-pt-empty" *ngIf="!availableColumns.length">Pick a dataset first to list its columns.</p>
      </div>

      <ng-container *ngTemplateOutlet="kvEditor; context: { rows: draft.staticValues, label: 'Static values (merged with row data)', hint: 'Enter text normally. JSON values are supported, for example an array containing uuid or the number 1.' }"></ng-container>
      <ng-container *ngTemplateOutlet="endpointEditor; context: { rows: draft.endpoints }"></ng-container>
      <ng-container *ngTemplateOutlet="kvEditor; context: { rows: draft.extraFields, label: 'Extra top-level fields', hint: 'e.g. entity, workflowId, version' }"></ng-container>

      <!-- Dynamic tokens available in Static values / Extra top-level fields.
           Resolved by the table at save time (see resolvePayloadTokens). -->
      <div class="pt-token-help">
        <strong>Dynamic values</strong>
        <small>Use these in <em>Static values</em> or <em>Extra top-level fields</em> — they're resolved when the save runs.</small>
        <div class="pt-token-list">
          <span class="pt-token"><code>{{ '{' }}userId{{ '}' }}</code> signed-in user id</span>
          <span class="pt-token"><code>{{ '{' }}userEmail{{ '}' }}</code> their email</span>
          <span class="pt-token"><code>{{ '{' }}userName{{ '}' }}</code> their username</span>
          <span class="pt-token"><code>{{ '{' }}now{{ '}' }}</code> ISO timestamp</span>
          <span class="pt-token"><code>{{ '{' }}componentId{{ '}' }}</code> this table</span>
          <span class="pt-token"><code>{{ '{' }}dataset{{ '}' }}</code> its dataset</span>
          <span class="pt-token"><code>{{ '{' }}column{{ '}' }}</code> that row's value (single-row saves)</span>
        </div>
      </div>
    </div>
    <div class="dvm-interactions-modal-foot">
      <button type="button" class="add-step-button" mat-stroked-button (click)="onCancel()">Cancel</button>
      <button type="button" class="add-step-button is-primary" mat-flat-button color="primary" (click)="onSave()">Save</button>
    </div>
  </div>
</div>
